/* global G */
import { asyncPipeSpread, translationsMap } from 'lib/util'

/**
 * Prints the name of the module being loaded to the console.
 *
 * @param {string} module module identifier to use in the sequence
 * @param {any} args      optional arguments
 * @returns {*[]}
 */
const log = (module, ...args) => {
  console.debug(`Module:"${module}"`)
  return [module, ...args]
}

/**
 * Set Session State MODULE parameter
 *
 * Uses session manager
 *
 * The method uses explicit deconstructing of arguments,
 * and has to rebuild the args array-like content as return value
 *
 *
 * @param {string} module - module identifier to use in the sequence
 * @param {*} args - optional arguments
 * @returns {function(*, ...[*]): *[]}
 */
// eslint-disable-next-line no-unused-vars
const setModule = () => async (module, ...args) => [`module/${module}`, ...args]

/**
 * Provides Module Configuration
 *
 * Uses session manager
 * Uses config provider
 *
 * @param {Gaia.Web.Application} obj - native application
 * @param {*} args - optional arguments
 * @returns {function(...[*]): *[]}
 */
const provideModuleConfiguration = obj => async (module, ...args) => [
  obj[G.PROVIDER].config(`${module}`), ...args,
]

/**
 * loads ns translation /:lng/:ns
 *
 * @param {Gaia.Web.Application} obj - native application
 * @returns {function(*=, ...[*]): *[]}
 */
const provideModuleTranslationNamespaces = obj => async (configuration, ...args) => {
  const { module, ns = [] } = configuration
  const namespace = translationsMap[module] || module
  await obj[G.ADAPTER][G.INTL].add([namespace, ...ns])
  return [configuration, ...args]
}

/**
 * Provides App Module Instance
 *
 * Uses platform content provider
 *
 * @param {Gaia.Web.webApplication} obj - native application
 * @param {*} args - optional arguments
 * @returns {function(...[*]): *[]}
 */
const provideModuleInstance = obj => async (configuration, ...args) => {
  const state = obj[G.SESSION][G.STATE]
  state[G.MODULE] = obj[G.PROVIDER].content(configuration)
  return args
}

export default obj => asyncPipeSpread(
  log,
  setModule(obj),
  provideModuleConfiguration(obj),
  provideModuleTranslationNamespaces(obj),
  provideModuleInstance(obj),
)
